import * as React from "react";
import {
    ApprovalRequest,
    Approvers,
    Data,
    ProposalApprovalRequestPermissions,
    ProposalApprovalRequirement,
    Staff
} from "./types.ts";
import Select from "react-select";
import {Control, Controller, UseFormRegister, useWatch} from "react-hook-form";
import smallSelect2Styles from "../Components/smallSelect2Styles.ts";

export function ApprovalRequestRow({
                                       item,
                                       approversLookup,
                                       itemPermissions,
                                       queueMode,
                                       index,
                                       data,
                                       statusList,
                                       register,
                                       control,
                                       disabled,
                                       validApprovers,
                                       inactive,
    approvalRequirement
                                   }:
                                       {
                                           approvalRequirement: ProposalApprovalRequirement,
                                           item: ApprovalRequest,
                                           approversLookup: Record<string, Staff>,
                                           itemPermissions: ProposalApprovalRequestPermissions,
                                           queueMode: boolean,
                                           index: number,
                                           data: Data,
                                           statusList: string[],
                                           register: UseFormRegister<{ proposalApprovalRequests: ApprovalRequest[] }>,
                                           control: Control<{ proposalApprovalRequests: ApprovalRequest[] }, undefined>,
                                           disabled: boolean,
                                           validApprovers: Approvers,
                                           inactive: boolean,
                                       }
) {
    const reviewStatusStyles = {
        'Approved': 'primary',
        'Awaiting Approval': 'secondary',
        'Change Requested': 'warning-subtle'
    };

    return (<tr key={item.id} style={{borderTop: 'none'}}>
        <td style={{width: '30%', whiteSpace: 'nowrap', paddingTop: 0, verticalAlign: 'top'}}>
            {/*{item.new && (*/}
            <input type='hidden'
                // @ts-expect-error react hook form doesn't like name registered with bracket syntax when using TS
                   {...register(`proposalApprovalRequests[${index}][id]`)} />
            <input name={`proposalApprovalRequests[${index}][approvalCategory]`} type='hidden'
                   value={item?.approvalCategory}/>
            <input name={`proposalApprovalRequests[${index}][approvalLevel]`} type='hidden'
                   value={item?.approvalLevel}/>
            <input name={`proposalApprovalRequests[${index}][approvalRequirementDetails]`} type='hidden'
                   value={approvalRequirement?.approvalRequirementDetails.toString()}/>
            <div className='d-flex justify-content-between gap-2'>
                {item.approvalStatus === 'Approved' ?
                    <div className="mb-1">
                        <input name={`proposalApprovalRequests[${index}][requestedApprover]`} type='hidden'
                               value={item?.requestedApprover?.pkStaffid}/>
                        <span
                            className='text-nowrap'>{item?.requestedApprover?.stfFirstname} {item?.requestedApprover?.stfLastname}</span>
                    </div>
                    : <div className='mb-1'><Controller
                        // @ts-expect-error react hook form doesn't like name registered with bracket syntax when using TS
                        name={`proposalApprovalRequests[${index}][requestedApprover]`}
                        control={control}
                        render={({field}) => <ApproversSelect
                            control={control}
                            key={item.id}
                            field={field}
                            currentCategory={item.approvalCategory}
                            queueMode={queueMode}
                            disabled={disabled || inactive}
                            validApprovers={item.approvalLevel === 2 ? validApprovers['l2 Approvers'] : [...validApprovers['l1 Approvers'], ...validApprovers['l2 Approvers']]}
                            selectedStaff={item.requestedApprover}
                        />
                        }
                    /></div>
                }
            </div>

            {itemPermissions?.['proposal_approval_request_status.edit'] && (data.permissions['proposal.approve'] || item.approvalStatus != 'Awaiting Approval')
                // && (!dateApproved || item.approvalStatus == 'Approved')
                ? (
                    <>
                        <div className={'d-flex'}>
                            {
                                statusList.map((v, i) => (
                                        <>
                                            <input
                                                // @ts-expect-error react hook form doesn't like name registered with bracket syntax when using TS
                                                {...register(`proposalApprovalRequests[${index}][approvalStatus]`)}
                                                disabled={(!data.permissions['proposal.approve'] && v === 'Approved') || inactive}
                                                type="radio"
                                                value={v}
                                                id={`as${index}_${i}`}
                                                className="btn-check"/>
                                            <label
                                                className={`btn btn-outline-${reviewStatusStyles[v]}`}
                                                htmlFor={`as${index}_${i}`}
                                                style={{
                                                    lineHeight: `${v == 'Approved' ? '2.2' : '1.2'}`,
                                                    width: '4rem',
                                                    whiteSpace: 'pre-wrap',
                                                    fontSize: '0.7rem',
                                                    padding: 0,
                                                    flexGrow: 1
                                                }}>
                                                {v}
                                            </label>
                                        </>
                                    )
                                )
                            }
                        </div>
                    </>

                )
                : !item.requestedApprover ? ''
                    : inactive ? 'Inactive Approval Request'
                        : (queueMode) ? (
                                'Queued Approval Request'
                            )
                            : (itemPermissions === undefined ? (
                                <>
                                    <input
                                        // @ts-expect-error react hook form doesn't like name registered with bracket syntax when using TS
                                        type='hidden' {...register(`proposalApprovalRequests[${index}][reviewStatus]`)} />
                                    Unsaved Approval Request
                                </>
                            ) : approversLookup[item.requestedApprover?.pkStaffid] || item?.approvalStatus == 'Approved' ? item?.approvalStatus : 'Invalid Approver')}
        </td>
        <td className='w-100 pt-0'>
            {(itemPermissions === undefined || itemPermissions?.['proposal_approval_request_notes.edit']) && (!inactive && !disabled) ? (
                // @ts-expect-error react hook form doesn't like name registered with bracket syntax when using TS
                <textarea {...register(`proposalApprovalRequests[${index}][notes]`)}
                          placeholder="Notes" style={{height: '100%'}}
                          className="form-control"></textarea>
            ) : !!item?.notes && <textarea readOnly={true} className='bg-transparent border'
                                           style={{
                                               outline: 'none',
                                               cursor: 'pointer',
                                               overflow: 'hidden',
                                               marginBottom: '-0.5em'
                                           }} value={item.notes}></textarea>}
        </td>
    </tr>);
}

function ApproversSelect({
                             queueMode,
                             validApprovers,
                             disabled,
                             field,
                             key,
                             currentCategory,
                             control
                         }:
                             {
                                 queueMode: boolean,
                                 disabled: boolean,
                                 validApprovers: Staff[],
                                 selectedStaff: Staff,
                                 field,
                                 currentCategory,
                                 key,
                                 control: Control<{ proposalApprovalRequests: ApprovalRequest[] }, undefined>,
                             }
) {

    const formWatched = useWatch({control, name: 'proposalApprovalRequests', defaultValue: []});


    if (field.value?.stfFirstname)
        field.value = {label: field.value.stfFirstname + ' ' + field.value.stfLastname, value: field.value.pkStaffid}


    return (
        <Select
            styles={smallSelect2Styles}
            key={key}
            isDisabled={disabled}
            options={Object.values(validApprovers)
                .filter(staff =>
                    !formWatched.some(
                        existingRequest =>
                            currentCategory !== 'Agreement Approval' &&
                            existingRequest.approvalCategory !== currentCategory &&
                            existingRequest.approvalCategory !== 'Agreement Approval' &&
                            (existingRequest.requestedApprover?.pkStaffid === staff.pkStaffid || existingRequest.requestedApprover?.value === staff.pkStaffid)
                    ))
                .map(staff => ({
                    label: staff.stfFirstname + ' ' + staff.stfLastname,
                    value: staff.pkStaffid
                }))
            }
            placeholder={queueMode ? 'Queue Approval Request From...' : 'Request Approval From...'}
            // defaultValue={{label: selectedStaff.stfFirstname + ' ' + selectedStaff.stfLastname, value: selectedStaff.pkStaffid}}
            {...field}
        />
    )
}
